"use strict";
import { colorsDark, colorsLight } from "ui/src/theme";
import { colors as baseColors } from "ui/src/theme/color/colors";
export const colors = {
  white: "#FFFFFF",
  black: "#000000",
  gray50: "#F5F6FC",
  gray100: "#E8ECFB",
  gray150: "#D2D9EE",
  gray200: "#B8C0DC",
  gray250: "#A6AFCA",
  gray300: "#98A1C0",
  gray350: "#888FAB",
  gray400: "#7780A0",
  gray450: "#6B7594",
  gray500: "#5D6785",
  gray550: "#505A78",
  gray600: "#404A67",
  gray650: "#333D59",
  gray700: "#293249",
  gray750: "#1B2236",
  gray800: "#131A2A",
  gray850: "#0E1524",
  gray900: "#0D111C",
  gray950: "#080B11",
  pink50: "#F9ECF1",
  pink100: "#FFD9E4",
  pink200: "#FBA4C0",
  pink300: "#FF6FA3",
  pink400: "#FB118E",
  pink500: "#C41969",
  pink600: "#8C0F49",
  pink700: "#55072A",
  pink800: "#350318",
  pink900: "#2B000B",
  pinkBase: "#FC74FE",
  pinkVibrant: "#F50DB4",
  red50: "#FAECEA",
  red100: "#FED5CF",
  red200: "#FEA79B",
  red300: "#FD766B",
  red400: "#FA2B39",
  red500: "#C4292F",
  red600: "#891E20",
  red700: "#530F0F",
  red800: "#380A03",
  red900: "#240800",
  redVibrant: "#F14544",
  yellow50: "#F6F2D5",
  yellow100: "#DBBC19",
  yellow200: "#DBBC19",
  yellow300: "#BB9F13",
  yellow400: "#A08116",
  yellow500: "#866311",
  yellow600: "#5D4204",
  yellow700: "#3E2B04",
  yellow800: "#231902",
  yellow900: "#180F02",
  yellowVibrant: "#FAF40A",
  // TODO: add gold 50-900
  gold200: "#EEB317",
  gold400: "#B17900",
  goldVibrant: "#FEB239",
  green50: "#E3F3E6",
  green100: "#BFEECA",
  green200: "#76D191",
  green300: "#40B66B",
  green400: "#209853",
  green500: "#0B783E",
  green600: "#0C522A",
  green700: "#053117",
  green800: "#091F10",
  green900: "#09130B",
  greenVibrant: "#5CFE9D",
  blue50: "#EDEFF8",
  blue100: "#DEE1FF",
  blue200: "#ADBCFF",
  blue300: "#869EFF",
  blue400: "#4C82FB",
  blue500: "#1267D6",
  blue600: "#1D4294",
  blue700: "#09265E",
  blue800: "#0B193F",
  blue900: "#040E34",
  blueVibrant: "#587BFF",
  // TODO: add magenta 50-900
  magenta300: "#FD82FF",
  magentaVibrant: "#FC72FF",
  purple300: "#8440F2",
  purple900: "#1C0337",
  purpleVibrant: "#6100FF",
  // TODO: add all other vibrant variations
  networkEthereum: "#627EEA",
  networkOptimism: "#FF0420",
  networkOptimismSoft: "rgba(255, 4, 32, 0.16)",
  networkPolygon: "#A457FF",
  networkArbitrum: "#28A0F0",
  networkBsc: "#F0B90B",
  networkPolygonSoft: "rgba(164, 87, 255, 0.16)",
  networkEthereumSoft: "rgba(98, 126, 234, 0.16)",
  networkBase: "#0052FF",
  networkBlast: "#fcfc03",
  // Spore colors
  neutral1_dark: colorsDark.neutral1,
  neutral1Hovered_dark: colorsDark.neutral1Hovered,
  neutral2_dark: colorsDark.neutral2,
  neutral2Hovered_dark: colorsDark.neutral2Hovered,
  neutral3_dark: colorsDark.neutral3,
  neutral3Hovered_dark: colorsDark.neutral3Hovered,
  surface1_dark: colorsDark.surface1,
  surface1_hovered_dark: colorsDark.surface1Hovered,
  surface2_dark: colorsDark.surface2,
  surface2_hovered_dark: colorsDark.surface2Hovered,
  surface3_dark: colorsDark.surface3,
  surface3Solid_dark: "#2F2F2F",
  surface3_hovered_dark: colorsDark.surface3Hovered,
  surface4_dark: colorsDark.surface4,
  surface5_dark: colorsDark.surface5,
  accent1_dark: colorsDark.accent1,
  accent1Hovered_dark: colorsDark.accent1Hovered,
  accent2_dark: colorsDark.accent2,
  accent2Hovered_dark: colorsDark.accent2Hovered,
  accent2Solid_dark: colorsDark.accent2Solid,
  accent3_dark: colorsDark.accent3,
  neutral1_light: colorsLight.neutral1,
  neutral1Hovered_light: colorsLight.neutral1Hovered,
  neutral2_light: colorsLight.neutral2,
  neutral2Hovered_light: colorsLight.neutral2Hovered,
  neutral3_light: colorsLight.neutral3,
  neutral3Hovered_light: colorsLight.neutral3Hovered,
  surface1_light: colorsLight.surface1,
  surface1_hovered_light: colorsLight.surface1Hovered,
  surface2_light: colorsLight.surface2,
  surface2_hovered_light: colorsLight.surface2Hovered,
  surface3_light: colorsLight.surface3,
  surface3Solid_light: "#ECECEC",
  surface3_hovered_light: colorsLight.surface3Hovered,
  surface4_light: colorsLight.surface4,
  surface5_light: colorsLight.surface5,
  accent1_light: colorsLight.accent1,
  accent1Hovered_light: colorsLight.accent1Hovered,
  accent2_light: colorsLight.accent2,
  accent2Hovered_light: colorsLight.accent2Hovered,
  accent2Solid_light: colorsLight.accent2Solid,
  accent3_light: colorsLight.accent3,
  success_light: colorsLight.statusSuccess,
  success_dark: colorsDark.statusSuccess,
  warning_light: colorsLight.statusWarning,
  warning_dark: colorsDark.statusWarning,
  warning2_light: colorsLight.statusWarning2,
  warning2_dark: colorsDark.statusWarning2,
  critical_light: colorsLight.statusCritical,
  critical_dark: colorsDark.statusCritical,
  critical2_dark: colorsDark.statusCritical2,
  critical2_light: colorsLight.statusCritical2,
  scrim: colorsLight.scrim
};
const commonTheme = {
  white: baseColors.white,
  black: baseColors.black,
  scrim: baseColors.scrim,
  transition: {
    duration: {
      slow: "500ms",
      medium: "250ms",
      fast: "125ms"
    },
    timing: {
      ease: "ease",
      in: "ease-in",
      out: "ease-out",
      inOut: "ease-in-out"
    }
  },
  chain_1: colors.networkEthereum,
  chain_3: colors.yellow400,
  chain_4: colors.pink400,
  chain_5: colors.green400,
  chain_10: colors.networkOptimism,
  chain_137: colors.networkPolygon,
  chain_42: colors.networkArbitrum,
  chain_56: colors.networkBsc,
  chain_420: colors.networkOptimism,
  chain_42161: colors.networkArbitrum,
  chain_421613: colors.networkArbitrum,
  chain_421614: colors.networkArbitrum,
  chain_80001: colors.networkPolygon,
  chain_43114: colors.networkOptimism,
  chain_137_background: colors.purple900,
  chain_10_background: colors.red900,
  chain_43114_background: colors.red900,
  chain_42161_background: colors.blue900,
  chain_84531: colors.networkBase,
  chain_56_background: colors.networkBsc,
  chain_81457: colors.networkBlast,
  chain_7777777: colors.neutral1_light,
  promotional: colors.magenta300,
  brandedGradient: "linear-gradient(139.57deg, #FF79C9 4.35%, #FFB8E2 96.44%);",
  promotionalGradient: colors.accent1_light
};
export const darkTheme = {
  // Your custom colors integrated into the theme system
  primary: "#0153ff",
  main: "#5d83e5",
  // Theme colors using your custom colors
  background: "#000000",
  backgroundHover: "#1a1a1a",
  backgroundPress: "#2a2a2a",
  backgroundFocus: "#2a2a2a",
  borderColor: "#333",
  borderColorHover: "#444",
  borderColorFocus: "#444",
  outlineColor: "#444",
  color: "#fff",
  colorHover: "#5d83e5",
  colorPress: "#5d83e5",
  colorFocus: "#5d83e5",
  shadowColor: "rgba(0,0,0,0.4)",
  shadowColorHover: "rgba(0,0,0,0.5)",
  // Accent colors using your primary and main colors
  accent1: "#0153ff",
  accent1Hovered: "rgba(1, 83, 255, 0.8)",
  accent1Pressed: "rgba(1, 83, 255, 0.6)",
  accent2: "#5d83e5",
  accent2Solid: "#5d83e5",
  accent2Hovered: "#0153ff",
  // Button styles
  buttonPrimary: "rgba(1, 83, 255, 0.6)",
  buttonPrimaryHover: "rgba(1, 83, 255, 0.8)",
  buttonPrimaryPress: "rgba(1, 83, 255, 0.4)",
  // Surface colors
  surface1: "#000000",
  surface1Hovered: "#1a1a1a",
  surface2: "#1a1a1a",
  surface2Hovered: "#2a2a2a",
  surface3: "#2a2a2a",
  surface3Solid: "#2a2a2a",
  surface3Hovered: "#333",
  surface4: "#333",
  surface5: "#444",
  surface5Hovered: "#555",
  // Neutral colors
  neutral1: "#fff",
  neutral1Hovered: "#f0f0f0",
  neutral2: "#ccc",
  neutral2Hovered: "#ddd",
  neutral3: "#999",
  neutral3Hovered: "#aaa",
  neutralContrast: "#fff",
  // Status colors
  statusSuccess: "#00c853",
  statusSuccessHovered: "#00e676",
  statusSuccess2: "#00c853",
  statusSuccess2Hovered: "#00e676",
  statusCritical: "#ff3d00",
  statusCriticalHovered: "#ff5722",
  statusCritical2: "#ff3d00",
  statusCritical2Hovered: "#ff5722",
  statusWarning: "#ffd600",
  statusWarningHovered: "#ffea00",
  statusWarning2: "#ffd600",
  statusWarning2Hovered: "#ffea00",
  // Additional theme properties
  success: "#00c853",
  warning: "#ffd600",
  warning2: "#ffea00",
  critical: "#ff3d00",
  critical2: "#ff5722",
  token0: "#0153ff",
  token1: "#5d83e5",
  deprecated_accentTextLightPrimary: "#fff",
  deprecated_accentFailureSoft: "rgba(255, 61, 0, 0.16)",
  deprecated_accentWarning: "#ffd600",
  // Keep other existing theme colors
  ...commonTheme
};
export const lightTheme = {
  ...commonTheme,
  ...darkTheme
  // For now, use dark theme colors for light theme
};
